import memoize from 'lodash/memoize';

/**
 * Creates a formatter for the given currency.
 *
 * @param  {string} currency
 * @return {Intl.NumberFormat}
 */
var formatterFor = function formatterFor(currency) {
  return new Intl.NumberFormat('en-US', {
    currency: currency,
    style: 'currency'
  });
};

// Memoizes formatter instances.
formatterFor = memoize(formatterFor);

/**
 * Formats the given value for the specified currency.
 *
 * @param  {Number} value
 * The value to format.
 *
 * @param  {string} currency
 * The currency to format as. Defaults to usd.
 *
 * @return {string}
 * The formatted currency.
 */
export default function formatCurrency(value) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'usd';
  return formatterFor(currency).format(value);
}
//# sourceMappingURL=formatCurrency.js.map
